import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'

interface DrawDataItem {
  title: string
  matCode: string
  thick: number
  texture: string
  data: Array<{
    plankWidth: number
    plankHeight: number
    isLocked?: boolean
    surplusInfo?: { isNotSurplus?: boolean }
  }>
  isDesMaterialNoCut?: boolean
  otherPlate?: { width: number; height: number }
}

interface Props {
  visible: boolean
  drawData: DrawDataItem[]
  selectStandardPlank: { plankWidth?: number; plankHeight?: number }
  xyReverse: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'm-material-relayout-modal',
  props: {
    visible: { type: Boolean },
    drawData: null,
    selectStandardPlank: null,
    xyReverse: { type: Boolean }
  },
  emits: ["update:visible", "onConfirm", "onCancel"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:visible', val: boolean): void
  (
    e: 'onConfirm',
    selectedTitles: string[],
    displayText: string,
    selectedIndices: number[]
  ): void
  (e: 'onCancel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean
  drawData: DrawDataItem[]
  selectStandardPlank: { plankWidth?: number; plankHeight?: number }
  xyReverse: boolean
}





const searchKeyword = ref('')
const selectedTitles = ref<string[]>([])

const materialOptions = ref<any[]>([])

watch(
  () => props.visible,
  (val) => {
    if (!val) return
    materialOptions.value = props.drawData
      .map((item, idx) => ({ ...item, drawDataIdx: idx }))
      .filter((item) => !item.isDesMaterialNoCut)
      .filter((item) => item.data.some((p) => !p.isLocked))
      .map((item) => {
        let width: number
        let height: number
        if (item.otherPlate) {
          // 特殊大板 直接读取 otherPlate
          width = item.otherPlate.width
          height = item.otherPlate.height
        } else {
          width = props.selectStandardPlank?.plankWidth ?? 0
          height = props.selectStandardPlank?.plankHeight ?? 0
        }
        // xyReverse 互换
        if (props.xyReverse) {
          ;[width, height] = [height, width]
        }
        const size = `${width}*${height}`
        return {
          title: item.title,
          thick: item.thick,
          matCode: item.matCode,
          texture: item.texture,
          size,
          searchText: `${item.thick}${item.matCode}${item.texture}${size}`,
          drawDataIdx: item.drawDataIdx,
        }
      })
  }
)

const filteredOptions = computed(() => {
  if (!searchKeyword.value) return materialOptions.value
  const keyword = searchKeyword.value.toLowerCase()
  return materialOptions.value.filter((item: any) =>
    item.searchText.toLowerCase().includes(keyword)
  )
})

const isAllSelected = computed(() => {
  return (
    filteredOptions.value.length > 0 &&
    filteredOptions.value.every((item: any) =>
      selectedTitles.value.includes(item.title)
    )
  )
})

const isIndeterminate = computed(() => {
  const selectedInFiltered = filteredOptions.value.filter((item: any) =>
    selectedTitles.value.includes(item.title)
  )
  return (
    selectedInFiltered.length > 0 &&
    selectedInFiltered.length < filteredOptions.value.length
  )
})

const handleSelectAll = (e: { target: { checked: boolean } }) => {
  if (e.target.checked) {
    const titlesToAdd = filteredOptions.value
      .map((item: any) => item.title)
      .filter((title) => !selectedTitles.value.includes(title))
    selectedTitles.value = [...selectedTitles.value, ...titlesToAdd]
  } else {
    const filteredTitles = new Set(
      filteredOptions.value.map((item: any) => item.title)
    )
    selectedTitles.value = selectedTitles.value.filter(
      (title) => !filteredTitles.has(title)
    )
  }
}

const handleConfirm = () => {
  const selectedItems = materialOptions.value.filter((item: any) =>
    selectedTitles.value.includes(item.title)
  )
  const selectedIndices = selectedItems.map((item: any) => item.drawDataIdx)
  const displayText = selectedItems
    .map(
      (item: any) => `${item.thick}${item.matCode}${item.texture}(${item.size})`
    )
    .join(', ')
  emits('onConfirm', [...selectedTitles.value], displayText, selectedIndices)
  emits('update:visible', false)
}

const handleCancel = () => {
  emits('onCancel')
  emits('update:visible', false)
}

watch(
  () => props.visible,
  (val) => {
    if (val) {
      searchKeyword.value = ''
      selectedTitles.value = []
    }
  }
)

watch(searchKeyword, () => {
  selectedTitles.value = []
})

return { __sfc: true,props, emits, searchKeyword, selectedTitles, materialOptions, filteredOptions, isAllSelected, isIndeterminate, handleSelectAll, handleConfirm, handleCancel }
}

})